export default {
  state: {
    data: false,
  },
  getters: {
    //
  },
  actions: {
    resetMath(context) {
      context.commit("updateMath", false)
    },
  },
  mutations: {
    updateMath(state, data) {
      return state.data = data
    }
  }
}